export default "__VITE_PUBLIC_ASSET__fddfff19__"